import { apiInstance, apiInstanceToken, apiSessionToken } from "./httpManager";
import Constant from "../../utils/Constant";
import axios from "axios";

const getPaymentStatusMessage = (Id) =>
  apiInstance.post("api/Renewal/GetPaymentStatusMessage", {
    Id: Id,
  });

const postLoginRequest = (
  userID,
  password,
  authClientID,
  authRedirectUrl,
  authState,
  recaptchaToken,
  code,
  twoFAReferenceCode
) =>
  apiInstance.post("api/LoginApi/LoginRequest", {
    UserID: userID,
    Password: password,
    //AppId: Constant.APP_ID_DEV_BASE,
    AppId: "778234A1-BB5E-47EB-8219-821211862A2D",
    AccountType: "Customer",
    AuthClientId: authClientID,
    AuthRedirectUrl: authRedirectUrl,
    AuthState: authState,
    RecaptchaToken: recaptchaToken,
    Code:code,
    ReferenceNumber:twoFAReferenceCode
  });

const postConfirmLoginRequest = (loginRequestKey, twoFAReferenceCode) =>
  apiInstance.post("api/LoginApi/ConfirmRequest", {
    LoginRequestKey: loginRequestKey,
    SMSCode: 8,
    ReferenceNumber: twoFAReferenceCode,
    //AppId: Constant.APP_ID_DEV_BASE,
    AppId: "778234A1-BB5E-47EB-8219-821211862A2D",
  });

const postForgotUserId = (userId, birthdate, recaptchaToken) =>
  apiInstance.post("api/LoginApi/ForgotUserId", {
    UserId: userId,
    Birthdate: birthdate,
    NeedsAdditionalValidation: false,
    RequestAppId: "778234A1-BB5E-47EB-8219-821211862A2D",
    AccountType: "Customer",
    RecaptchaToken: recaptchaToken,
  });

const getCurrentUserId = (userId, code2Fa, otpReference) =>
  apiInstance.post("api/LoginApi/GetCurrentUserId", {
    NRIC: userId,
    Code2fa: code2Fa,
    OtpReference: otpReference,
  });

const resendOtp = (userId, recaptchaToken) =>
  apiInstance.post("api/LoginApi/ResendOTP", {
    NRIC: userId,
    RecaptchaToken: recaptchaToken,
  });

const forgotPasswordReq = (userId, birthdate, recaptchaToken) =>
  apiInstance.post("api/LoginApi/ForgotPassword", {
    UserId: userId,
    Birthdate: birthdate,
    NeedsAdditionalValidation: false,
    RequestAppId: "778234A1-BB5E-47EB-8219-821211862A2D",
    AccountType: "Customer",
    RecaptchaToken: recaptchaToken,
  });

const verifyForgotPassOtpRequest = (code2Fa, otpReference) =>
  apiInstance.post("api/LoginApi/Verify2FAPage", {
    Code: code2Fa,
    ReferenceNumber: otpReference,
  });

const changePasswordRequest = (
  userId,
  password,
  confirmPassword,
  otpReference
) =>
  apiInstance.post("api/LoginApi/ChangePassword", {
    NRIC: userId,
    Password: password,
    ConfirmPassword: confirmPassword,
    OtpReference: otpReference,
  });

const loginSGPQR = (code, state, error, error_description) =>
  apiInstance.post("api/LoginApi/SGPQR", {
    code: code,
    state: state,
    error: error,
    error_description: error_description,
  });

const loginPortal = (actionId, authClientId, authRedirectUrl, authState) =>
  apiInstance.post("api/LoginApi/GetLoginMaintenance", {
    requestAppId: "778234A1-BB5E-47EB-8219-821211862A2D",
    accountType: "Customer",
    actionId: actionId,
    authClientId: authClientId,
    authRedirectUrl: authRedirectUrl,
    authState: authState,
  });

const getAuthorizationAuth = (authState, authRedirectUrl) =>
  apiInstance.post("api/LoginApi/GetAuthCode", {
    AuthState: authState,
    AuthRedirectUrl: authRedirectUrl,
  });

const registrationReq = (nric, recaptchaToken) =>
  apiInstance.post("api/LoginApi/Registration", {
    NRIC: nric,
    RecaptchaToken: recaptchaToken,
    RequestAppId: "778234A1-BB5E-47EB-8219-821211862A2D",
  });

const registrationOTPReq = (nric) =>
  apiInstance.post("api/LoginApi/GenerateMobileTwoFA", {
    NRIC: nric,
  });

const registrationOTPResend = (nric) =>
  apiInstance.post("api/LoginApi/SendOTP", {
    NRIC: nric,
  });

const registrationVerifyOTP = (
  nric,
  otpReference,
  c2facode,
  mobileNo,
  mobileCountryCode
) =>
  apiInstance.post("api/LoginApi/GetClientInfo", {
    NRIC: nric,
    OTPReference: otpReference,
    C2fACode: c2facode,
    AppId: "778234A1-BB5E-47EB-8219-821211862A2D",
    MobileNumber: mobileNo,
    MobileCountryCode: mobileCountryCode,
  });

const registrationUpdateClientInfo = (
  nric,
  userId,
  password,
  email,
  dateOfBirth,
  name
) =>
  apiInstance.post("api/LoginApi/UpdateClientInfo", {
    NRIC: nric,
    UserId: userId,
    Password: password,
    Email: email,
    DateOfBirth: dateOfBirth,
    Name: name,
    AppId: "ECD6169C-36C8-4917-9EB8-4829B382FAA",
  });

const getAuthToken = (nric) =>
  axios.post(
    process.env.REACT_APP_ACCOUNT_SERVICE_API_URL + "api/Admin/GenerateToken",
    {
      nric: nric,
    }
  );

const activationGenericLink = (userID, password, confirmPassword, nric, dob) =>
  apiInstance.post("api/Register/Activation", {
    UserID: userID,
    Password: password,
    ConfirmPassword: confirmPassword,
    NRIC: nric,
    DateOfBirth: dob,
    AppId: "ECD6169C-36C8-4917-9EB8-4829B382FAA",
  });

const activationGenericValidateOTP = (
  nric,
  otpReferenceNo,
  code,
  password,
  userID
) =>
  apiInstance.post("api/Register/ValidateOTPActivation", {
    NRIC: nric,
    OtpReferenceNo: otpReferenceNo,
    Code: code,
    AppId: "ECD6169C-36C8-4917-9EB8-4829B382FAA",
    Password: password,
    UserID: userID,
    Is_Activation_From_Link: true,
  });

const activationPersonalLinkUrl = (q, a, r) =>
  apiInstance.post("api/Register/ActivateLink", {
    q: q,
    a: a,
    r: r,
  });

const activationPersonalLink = (
  nric,
  userID,
  password,
  confirmPassword,
  nricFromLink
) =>
  apiInstance.post("api/Register/Activate", {
    NRIC: nric,
    UserID: userID,
    AppId: "ECD6169C-36C8-4917-9EB8-4829B382FAA",
    Password: password,
    ConfirmPassword: confirmPassword,
    NRICFromLink: nricFromLink,
  });

const checkRenewability = (submitData) =>
  apiInstance.post("api/LoginApi/CheckRenewability", submitData);
const renewalPayNow = (premium, orderNo, nric, policyNo, isRecurring) =>
  apiInstance.post("api/LoginApi/RenewalPayment", {
    Premium: premium,
    OrderNumber: orderNo,
    Nric: nric,
    PolicyNumber: policyNo,
    isRecurring: isRecurring,
  });

const getStatusMessage = (orderNo) =>
  apiInstance.post("api/LoginApi/GetPaymentRenewalStatusMessage", {
    OrderNumber: orderNo,
  });

const promptMobilePhoneInput = (nric, mobileNo, mobileCountryCode, recaptchaToken) =>
  apiInstance.post("api/LoginApi/CreateUsingMobileActivation", {
    NRIC: nric,
    MobileNumber: mobileNo,
    MobileCountryCode: mobileCountryCode,
    RecaptchaToken: recaptchaToken
  });

const getSingPass = (authState, authCode) =>
  apiInstance.post("api/LoginApi/GetSingPass", {
    Auth_State: authState,
    Auth_Code: authCode,
  });

const renewalTiqHome = (submitData) =>
  apiInstance.post("Payment/RenewalTiqHome", submitData);

const getDDAPolicy = (policyNumber,GiroReference) =>
  apiInstance.post("api/LoginApi/GetDDAPolicy", {
    Policy_Number: policyNumber,
    GiroReference:GiroReference
  });

const createEDDA = (
  policyNumber,
  policyName,
  premium,
  bankID,
  transactionType,
  orderNumber,
  ewalletAmount,
  isRecurring
) =>
  apiInstance.post("api/LoginApi/CreateeDDA", {
    Policy_Number: policyNumber,
    Policy_Name: policyName,
    Premium: premium,
    Bank_Code: bankID,
    TransactionType: transactionType,
    OrderNumber: orderNumber,
    EwalletAmount: ewalletAmount,
    IsRecurring: isRecurring,
  });

const getGIROBankList = (transactionType) =>
  apiInstance.post("api/LoginApi/GeteDDABankList", {
    TransactionType: transactionType,
  });

const getGiroCallBackData = (id) =>
  apiInstance.post("api/LoginApi/GeteDDACallbackData", { id: id });

const getGiroCallBackExist = (ddaRefNo, bankTransId) =>
  apiInstance.post("api/LoginApi/eDDACallbackExist", {
    DDA_Reference_No: ddaRefNo,
    Transaction_Reference_No: bankTransId,
  });

const submitGiro = (
  ddaRefNo,
  bankTransId,
  payorName,
  payorNric,
  payorRelationship,
  attachedFile,
  isThirdParty,
  isMatch
) =>
  apiInstance.post("api/LoginApi/v3/SubmiteDDA", {
    DDA_Reference_No: ddaRefNo,
    Transaction_Reference_No: bankTransId,
    Payor_Name: payorName,
    Payor_NRIC: payorNric,
    Payor_Relationship: payorRelationship,
    Attached_Files: attachedFile,
    Is_Third_Party: isThirdParty,
    Is_Match: isMatch,
  });

const getGiroSubmitCallBackExist = (ddaRefNo, bankTransId) =>
  apiInstance.post("api/LoginApi/EnquireeDDASubmission", {
    DDA_Reference_No: ddaRefNo,
    Transaction_Reference_No: bankTransId,
  });

const twilioGetFileStatus = (fileName) =>
  apiInstance.post("api/LoginApi/TwilioGetFileStatus", {
    fileName: fileName,
  });

const twilioRequestOTP = (fileName) =>
  apiInstance.post("api/LoginApi/TwilioRequestOTP", {
    fileName: fileName,
  });

const twilioGetFile = (fileName, otpCode) =>
  apiInstance.post("api/LoginApi/TwilioGetFile", {
    fileName: fileName,
    OtpCode: otpCode,
  });

const enroleGiro = (ddaRefNo, transactionRefNo) =>
  apiInstance.post("api/LoginApi/EnroleGiro", {
    DDA_Reference_No: ddaRefNo,
    Transaction_Reference_No: transactionRefNo,
  });

//LiveChat
const getChatConfiguration = () =>
  (window.sessionStorage.getItem("MyToken") === "NotUsingThisMethod"
    ? apiSessionToken
    : apiInstance
  ).post("api/ChatApi/GetConfiguration", {
    DeviceId: "",
  });

const getCreateChat = (sessionId) =>
  (window.sessionStorage.getItem("MyToken") === "NotUsingThisMethod"
    ? apiSessionToken
    : apiInstance
  ).post("api/ChatApi/CreateChatV2", {
    RequestAppId: "778234A1-BB5E-47EB-8219-821211862A2D",
    SessionId: sessionId,
  });

const getChatUpdate = (threadID, loginId) =>
  (window.sessionStorage.getItem("MyToken") === "NotUsingThisMethod"
    ? apiSessionToken
    : apiInstance
  ).post("api/ChatApi/GetChatUpdateV2", {
    ThreadId: threadID,
    LoginId: loginId,
  });

const getChatMessage = (threadID, loginId) =>
  (window.sessionStorage.getItem("MyToken") === "NotUsingThisMethod"
    ? apiSessionToken
    : apiInstance
  ).post("api/ChatApi/GetChatMessageV2", {
    ThreadId: threadID,
    LoginId: loginId,
  });
//MessageType
//  Text = 1,
// File = 2,
// Image = 3,
// Recording = 4,
// Appointment = 5,
const getCreateMessage = (
  threadID,
  content,
  messageType,
  payload,
  attachedFiles,
  intent,
  level,
  loginId
) =>
  (window.sessionStorage.getItem("MyToken") === "NotUsingThisMethod"
    ? apiSessionToken
    : apiInstance
  ).post("api/ChatApi/CreateChatMessageV2", {
    ThreadId: threadID,
    Content: content,
    CreatedBy: "Customer",
    MessageType: messageType,
    Payload: payload,
    AttachedFiles: attachedFiles,
    Intent: intent,
    Level: level,
    LoginId: loginId,
  });

const getTwilioQuitQueue = (threadID) =>
  (window.sessionStorage.getItem("MyToken") === "NotUsingThisMethod"
    ? apiSessionToken
    : apiInstance
  ).post("api/ChatApi/TwilioQuitQueue", {
    ThreadId: threadID,
  });

const getScheduleCallBack = (threadID) =>
  (window.sessionStorage.getItem("MyToken") === "NotUsingThisMethod"
    ? apiSessionToken
    : apiInstance
  ).post("api/ChatApi/ScheduleCallback", {
    ThreadId: threadID,
  });

const getDisabledTimeLists = (date) =>
  (window.sessionStorage.getItem("MyToken")
    ? apiSessionToken
    : apiInstance
  ).post("api/ChatApi/DisabledTimeLists", {
    Date: date,
  });

const createAppointment = (
  threadID,
  bookSTime,
  bookETime,
  customerN,
  email,
  mobile
) =>
  (window.sessionStorage.getItem("MyToken") === "NotUsingThisMethod"
    ? apiSessionToken
    : apiInstance
  ).post("api/ChatApi/CreateAppointment", {
    ThreadId: threadID,
    BookingStartTime: bookSTime,
    BookingEndTime: bookETime,
    CustomerName: customerN,
    Email: email,
    Mobile: mobile,
    RequestAppId: "778234A1-BB5E-47EB-8219-821211862A2D",
  });

const validateMovieReg = (nric, dob) =>
  apiInstance.post("api/LoginApi/ValidateMovieRegistration", {
    Nric: nric,
    Dob: dob,
  });

const submitMovieReg = (otp, otpReference) =>
  apiInstance.post("api/LoginApi/SubmitMovieRegistration", {
    Otp: otp,
    OtpReference: otpReference,
  });

const confirmPayEddaGiRenewal = (orderNumber) =>
  window.localStorage.getItem("MyToken")
    ? apiInstanceToken.post("api/LoginApi/ConfirmPayEddaGiRenewal", {
      OrderNumber: orderNumber,
    })
    : apiInstance.post("api/LoginApi/ConfirmPayEddaGiRenewal", {
      OrderNumber: orderNumber,
    });

const getMaintenanceMsg = () =>
  apiInstance.post("api/LoginApi/GetMaintenanceMessage", {
    RequestAppId: "778234A1-BB5E-47EB-8219-821211862A2D",
    PageId: 1
  });

const getProfile = () =>
  apiSessionToken.post("api/CustomerServiceApi/GetClientOrLoginProfile", {});

const getChatReplyStatus = (chatid, feedbackStatus) =>
  apiInstance.post("api/ChatApi/SetChatReplyStatus", {
    ChatId: chatid,
    FeedbackStatus: feedbackStatus,
  });

const connectLiveChat = (threadID) =>
  apiInstance.post("api/ChatApi/ConnectLiveChat", {
    ThreadId: threadID,
  });

const getInsiderClientInfoReq = () =>
  apiSessionToken.post("api/CustomerServiceApi/GetInsiderClientInfo", {});

const singtelPartnershipLeadsReq = (submitData) =>
  apiInstance.post("/api/LoginApi/SingtelPartnershipLeads", submitData);

const submitCampaignFormReq = (submitData) =>
  apiInstance.post("api/LoginApi/SubmitCampaignForm", submitData);

const calculateWalkWagAmountReq = (submitData) =>
  apiInstance.post("api/LoginApi/CalculateWalkWagAmount", submitData);

const checkPayNowQRStatusReq = (submitData) =>
  apiInstance.post("api/LoginApi/CheckPayNowQRStatus", submitData);

const getRegistrationCustomerDetails = (submitData) =>
  apiInstance.post("api/LoginApi/GetRegistrationCustomerDetails", submitData);

const registerNewCustomer = (submitData) =>
  apiInstance.post("api/LoginApi/RegisterNewCustomer", submitData);

//Onboarding Revamp v2.0
const getRegistrationCustomerInfo = (submitData) =>
  apiInstance.post("api/LoginApi/GetRegistrationCustomerInfo", submitData);
const getLoginToken = (submitData) =>
  apiInstance.post("api/LoginApi/GetLoginToken", submitData);
const generateOTPOnboarding = (submitData) =>
  apiInstance.post("api/LoginApi/GenerateOTPOnboarding", submitData);
const registerNewCustomerv2 = (submitData) =>
  apiInstance.post("api/LoginApi/RegisterNewCustomerv2", submitData);
const logRegistrationRequest = (submitData) =>
  apiInstance.post("api/LoginApi/LogRegistrationRequest", submitData);

const validateRegistration = (submitData) =>
  apiInstance.post("api/LoginApi/ValidateRegistration", submitData);
const uploadOcrNric = (submitData) =>
  apiInstance.post("api/LoginApi/UploadOcrNric", submitData);
const updateClientInfov4 = (submitData) =>
  apiInstance.post("api/LoginApi/UpdateClientInfov4", submitData);

const generateLoginOtp = (submitData) =>
  apiInstance.post("api/LoginApi/GenerateLoginOtp", submitData);


export default {
  getPaymentStatusMessage,
  postLoginRequest,
  postConfirmLoginRequest,
  postForgotUserId,
  getCurrentUserId,
  resendOtp,
  forgotPasswordReq,
  verifyForgotPassOtpRequest,
  changePasswordRequest,
  loginSGPQR,
  loginPortal,
  getAuthorizationAuth,
  registrationReq,
  registrationOTPReq,
  registrationVerifyOTP,
  registrationUpdateClientInfo,
  getAuthToken,
  activationGenericLink,
  activationGenericValidateOTP,
  activationPersonalLinkUrl,
  activationPersonalLink,
  checkRenewability,
  renewalPayNow,
  getStatusMessage,
  promptMobilePhoneInput,
  getSingPass,
  registrationOTPResend,
  renewalTiqHome,
  getDDAPolicy,
  createEDDA,
  getGIROBankList,
  getGiroCallBackData,
  getGiroCallBackExist,
  submitGiro,
  getGiroSubmitCallBackExist,
  twilioGetFileStatus,
  twilioRequestOTP,
  twilioGetFile,
  enroleGiro,

  getChatConfiguration,
  getCreateChat,
  getChatUpdate,
  getChatMessage,
  getCreateMessage,
  getTwilioQuitQueue,

  getScheduleCallBack,
  getDisabledTimeLists,
  createAppointment,
  validateMovieReg,
  submitMovieReg,
  confirmPayEddaGiRenewal,

  getMaintenanceMsg,
  getProfile,
  getChatReplyStatus,
  connectLiveChat,
  getInsiderClientInfoReq,
  singtelPartnershipLeadsReq,

  submitCampaignFormReq,
  calculateWalkWagAmountReq,
  checkPayNowQRStatusReq,
  getRegistrationCustomerDetails,
  registerNewCustomer,
  //onboarding revamp v2.0
  getRegistrationCustomerInfo,
  getLoginToken,
  generateOTPOnboarding,
  registerNewCustomerv2,
  logRegistrationRequest,
  validateRegistration,
  uploadOcrNric,
  updateClientInfov4,
  generateLoginOtp
};
